var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preparedTimeLineData)?_c('div',{staticClass:"scale"},_vm._l((_vm.preparedTimeLineData),function(item){return _c('photo-time-line-scale-item',{key:item.id,attrs:{"item-data":item,"current-photo-id":_vm.currentPhotoId},on:{"on-send-photo-id":_vm.sendPhotoId}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }